export const Options = {
    BecomingAwareThrough: [
        { text: "Agentur für Arbeit", value: "Agentur für Arbeit" },
        { text: "Aubiplus", value: "Aubiplus" },
        { text: "azubify", value: "azubify" },
        { text: "Azubiyo", value: "Azubiyo" },
        { text: "Bekannte, Verwandte, Freunde", value: "Bekannte, Verwandte, Freunde" },
        { text: "Berufemesse", value: "Berufemesse" },
        { text: "IHK Ausbildungsatlas", value: "IHK Ausbildungsatlas" },
        { text: "IHK Ausbildungsbörse", value: "IHK Ausbildungsbörse" },
        { text: "Indeed", value: "Indeed" },
        { text: "Jobbörse", value: "Jobbörse" },
        { text: "Job-OWL", value: "Job-OWL" },
        { text: "meineStadt.de", value: "meineStadt.de" },
        { text: "Mitarbeiterempfehlung", value: "Mitarbeiterempfehlung" },
        { text: "Monster", value: "Monster" },
        { text: "Plakate", value: "Plakate" },
        { text: "Praktikum", value: "Praktikum" },
        { text: "Radiospot", value: "Radiospot" },
        { text: "Schnuppertag/Tagespraktikum", value: "Schnuppertag/Tagespraktikum" },
        { text: "SchuBS", value: "SchuBS" },
        { text: "Stepstone", value: "Stepstone" },
        { text: "Tageszeitung", value: "Tageszeitung" },
        { text: "Westfalen Weser Homepage", value: "Westfalen Weser Homepage" },
        { text: "Weiteres/Sonstiges", value: "Weiteres/Sonstiges" },
    ]
}
